import { createSlice } from '@reduxjs/toolkit';

import type { IBuildingCard } from 'shared/types/buildingCard';

/** Данные приходят только из SSR (preloadedState), экшенов нет */
const buildingCardSlice = createSlice({
  initialState: {} as IBuildingCard,
  name: 'buildingCard',
  reducers: {},
});

export const { reducer: buildingCardReducer } = buildingCardSlice;
